<template>
  <div class="container">
    <orders-table
      v-if="orders"
      :orders="orders"
      :account="account"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { OrdersTable } from '@/components/orders';

export default {
  name: 'Orders',
  components: {
    'orders-table': OrdersTable,
  },
  data() {
    return {
      orders: [],
      account: null,
      detailsOpen: false,
    };
  },
  async mounted() {
    this.orders = await this.allOrders(this.$route.query);
    if (this.$route.query.accountId) {
      this.account = await this.getAccount(this.$route.query.accountId);
    }

    this.detailsOpen = true;
  },
  methods: {
    ...mapActions(['allOrders', 'getAccount']),
  },

};
</script>


<style lang="scss" scoped>
.orderDetails {
  padding-left: 16px;
  padding-right: 16px;
}
.orderField {
  padding: 8px;
}
.transactions {
  max-height: 500px;
  overflow-y: auto;
}
.transactionField {
  padding-top: 8px;
}
.toolbar {
  background-color: #1a4c7d;
}
</style>



// WEBPACK FOOTER //
// src/views/orders/Orders.vue